/**
 * @type {Record<keyof typeof import('../stubs').DEFAULT_TODOS, {
 *  title: string,
 *  description: string,
 *  linkText: string
 *  linkTo: string,
 * }>}
 */
export const ADDITIONAL_TODOS_DATA = {
  BRANDED_THEME: {
    title: 'Brand customer returns portal',
    description:
      'Customize your customer-facing returns page with branding, logos and more.',
    linkText: 'Configure Returns Portal',
    linkTo: '/configure/customer-portal/branded-theme'
  },
  EMAIL_TEMPLATES: {
    title: 'Customize email templates',
    description:
      'Personalize notifications with your branding and manage audience targeting.',
    linkText: 'Setup Email Templates',
    linkTo: '/configure/customer-portal/email-communications'
  },
  EXCHANGES_CONFIG: {
    title: 'Setup exchanges',
    description:
      'Enable exchanges to keep more revenue and make returns easier for your customers.',
    linkText: 'Configure Exchanges',
    linkTo: '/configure/return-management/exchanges'
  }
};
